import { createContext } from 'preact';
import { StateUpdater } from 'preact/hooks';

export interface Country {
  ID: number;
  Code: string;
  Name: string;
}

export interface Address {
  ID: number;
  AddressLine1: string;
  AddressLine2: string;
  AddressLine3: string;
  AddressLine4: string;
  City: string;
  County: string;
  Country: Country;
  PostCode: string;
}

export interface Customer {
  ID: number;
  Code: string;
  Name: string;
}

export interface Contact {
  ID: number;
  FullName: string;
}

export interface SalesRep {
  ID: number;
  Code: string;
  Name: string;
}

export interface Branch {
  ID: number;
  Code: string;
  Description: string;
}

export interface DespatchBranch {
  ID: number;
  Code: string;
  Description: string;
}

export interface WorkflowStatus {
  ID: number;
  Code: string;
  Description: string;
}

export interface OrderType {
  ID: number;
  Code: string;
  Description: string;
}

export interface Currency {
  ID: number;
  Code: string;
  Description: string;
}

export interface DeliveryAgent {
  ID: number;
  Code: string;
  Description: string;
}

export interface DeliveryTaxRate {
  ID: number;
  Code: string;
  Description: string;
}

export interface Product {
  ID: number;
  Code: string;
  Description: string;
}

export interface TaxRate {
  ID: any;
  Code: string;
  Description: string;
}

export interface PricingStatus {
  Value: string;
  Name: string;
}

export interface PriceSource {
  Value: string;
  Name: string;
}

export interface SellingUnits {
  ID: any;
  Description: string;
}

export interface Item2 {
  ID: any;
  Product: Product;
  Description: string;
  Quantity: number;
  QuantitySupplied: number;
  NetPrice: number;
  GrossPrice: number;
  NetAmount: number;
  TaxRate: TaxRate;
  TaxAmount: number;
  GrossAmount: number;
  PricingStatus: PricingStatus;
  PriceSource: PriceSource;
  D_NoLaterThanDate: Date;
  SellingUnits: SellingUnits;
}

export interface SalesOrder {
  ID: number;
  Date: string;
  DueDate: string;
  Number: string;
  Customer: Customer;
  Contact: Contact;
  SalesRep: SalesRep;
  Branch: Branch;
  DespatchBranch: DespatchBranch;
  WorkflowStatus: WorkflowStatus;
  OrderType: OrderType;
  Currency: Currency;
  DeliveryAgent: DeliveryAgent;
  DeliveryNetAmount: number;
  DeliveryTaxRate: DeliveryTaxRate;
  DeliveryTaxAmount: number;
  DeliveryGrossAmount: number;
  NetAmount: number;
  TaxAmount: number;
  GrossAmount: number;
  Items: Item2[];
  Receipts: any[];
}

export interface Item {
  Address: Address;
  SalesOrder: SalesOrder;
}

export interface KeyValueMapping {
  Key: string;
  Value: string;
}

export interface MyOrdersData {
  items: Item[];
  SellingUnitMapping: KeyValueMapping[];
  StockingStatusMapping: KeyValueMapping[];
  ImageMapping: KeyValueMapping[];
  OrderStatuses: KeyValueMapping[];
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
}

export interface SearchOrderProps {
  page: number;
  limit: number;
  filters?: any[];
  order: string;
  active: boolean;
  orderStatus: string;
}

export interface OrdersProps {
  items?: Item[];
  setItems?: StateUpdater<Item[]>;
  search?: SearchOrderProps;
  setSearch?: StateUpdater<SearchOrderProps>;
  orderStatuses?: KeyValueMapping[];
  setOrderStatuses?: StateUpdater<KeyValueMapping[]>;
  stockingStatusMapping?: KeyValueMapping[];
  setStockingStatusMapping?: StateUpdater<KeyValueMapping[]>;
  sellingUnitMapping?: KeyValueMapping[];
  setSellingUnitMapping?: StateUpdater<KeyValueMapping[]>;
  imageMapping?: KeyValueMapping[];
  setImageMapping: StateUpdater<KeyValueMapping[]>;
  handleFreshSearch?: (
    searchdata: Partial<SearchOrderProps>
  ) => Promise<{
    data: any;
    error: any;
  }>;
}

export const Orders = createContext<OrdersProps>({
  search: {
    page: 1,
    limit: 8,
    filters: [],
    order: 'alphabeticallyAscending',
    active: true,
    orderStatus: 'ALL',
  },
  items: [],
  setItems: undefined,
  orderStatuses: [],
  setOrderStatuses: undefined,
  stockingStatusMapping: [],
  setStockingStatusMapping: undefined,
  sellingUnitMapping: [],
  setSellingUnitMapping: undefined,
  imageMapping: [],
  setImageMapping: undefined,
});
